<!-- Start Breadcrumbs -->
<app-breadcrumbs
	title="Listjs"
	[breadcrumbItems]="breadCrumbItems"
></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Add, Edit & Remove</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<div id="customerList">
					<div class="row g-4 mb-3">
						<div class="col-sm-auto">
							<div class="d-flex gap-1">
								<button
									type="button"
									class="btn btn-success add-btn"
									data-bs-toggle="modal"
									id="create-btn"
									data-bs-target="#showModal"
									(click)="openModal(content)"
								>
									<i
										class="ri-add-line align-bottom me-1"
									></i>
									Add
								</button>
								<button
									class="btn btn-soft-danger"
									onClick="deleteMultiple()"
								>
									<i class="ri-delete-bin-2-line"></i>
								</button>
							</div>
						</div>
						<div class="col-sm">
							<div class="d-flex justify-content-sm-end">
								<div class="search-box ms-2">
									<input
										type="text"
										class="form-control search"
										placeholder="Search..."
										[(ngModel)]="service.searchTerm"
									/>
									<i class="ri-search-line search-icon"></i>
								</div>
							</div>
						</div>
					</div>

					<div class="table-responsive table-card mt-3 mb-1">
						<table class="table">
							<thead>
								<tr class="bg-light text-muted">
									<th scope="col" style="width: 50px">
										<div class="form-check">
											<input
												class="form-check-input"
												type="checkbox"
												id="checkAll"
												value="option"
												[(ngModel)]="masterSelected"
												(change)="checkUncheckAll()"
											/>
										</div>
									</th>
									<th class="sort" data-sort="customer_name">
										Customer
									</th>
									<th class="sort" data-sort="email">
										Email
									</th>
									<th class="sort" data-sort="phone">
										Phone
									</th>
									<th class="sort" data-sort="date">
										Joining Date
									</th>
									<th class="sort" data-sort="status">
										Delivery Status
									</th>
									<th class="sort">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let data of ListJsList$ | async">
									<th scope="row">
										<div class="form-check">
											<input
												class="form-check-input"
												type="checkbox"
												name="checkAll"
												value="option1"
												[(ngModel)]="data.isSelected"
											/>
										</div>
									</th>
									<td>
										<ngb-highlight
											[result]="data.customer_name"
											[term]="service.searchTerm"
										></ngb-highlight>
									</td>
									<td>
										<ngb-highlight
											[result]="data.email"
											[term]="service.searchTerm"
										></ngb-highlight>
									</td>
									<td>
										<ngb-highlight
											[result]="data.phone"
											[term]="service.searchTerm"
										></ngb-highlight>
									</td>
									<td>
										<ngb-highlight
											[result]="data.date"
											[term]="service.searchTerm"
										></ngb-highlight>
									</td>
									<td class="status">
										<span
											class="badge badge-soft-{{
												data.status_color
											}} text-uppercase"
											>{{ data.status }}</span
										>
									</td>
									<td>
										<div class="d-flex gap-2">
											<div class="edit">
												<button
													class="btn btn-sm btn-success edit-item-btn"
													data-bs-toggle="modal"
													data-bs-target="#showModal"
													(click)="openModal(content)"
												>
													Edit
												</button>
											</div>
											<div class="remove">
												<button
													class="btn btn-sm btn-danger remove-item-btn"
													data-bs-toggle="modal"
													data-bs-target="#deleteRecordModal"
													(click)="confirm()"
												>
													Remove
												</button>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div
						class="row justify-content-md-between align-items-md-center"
					>
						<div class="col col-sm-6">
							<div
								class="dataTables_info mb-2"
								id="tickets-table_info"
								role="status"
								aria-live="polite"
							>
								Showing
								{{ service.startIndex }} to
								{{ service.endIndex }} of
								{{ service.totalRecords }}
								entries
							</div>
						</div>
						<!-- Pagination -->
						<div class="col col-sm-6">
							<div
								class="text-sm-right float-sm-end listjs-pagination"
							>
								<ngb-pagination
									[collectionSize]="(total$ | async)!"
									[(page)]="service.page"
									[pageSize]="service.pageSize"
								>
								</ngb-pagination>
							</div>
						</div>
						<!-- End Pagination -->
					</div>
				</div>
			</div>
			<!-- end card -->
		</div>
		<!-- end col -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<!-- Add ListJs Data -->
<ng-template #content role="document" let-modal>
	<div class="modal-header bg-light p-3">
		<h5 class="modal-title" id="exampleModalLabel">Add Customer</h5>
		<button
			type="button"
			class="btn-close"
			data-bs-dismiss="modal"
			aria-label="Close"
			id="close-modal"
			(click)="modal.dismiss('Cross click')"
		></button>
	</div>
	<form (ngSubmit)="saveListJs()" [formGroup]="listJsForm">
		<div class="modal-body">
			<div class="mb-3" id="modal-id" style="display: none">
				<label for="id-field" class="form-label">ID</label>
				<input
					type="text"
					id="id-field"
					class="form-control"
					placeholder="ID"
					readonly
				/>
			</div>

			<div class="mb-3">
				<label for="customername-field" class="form-label"
					>Customer Name</label
				>
				<input
					type="text"
					id="customername-field"
					class="form-control"
					placeholder="Enter Name"
					required
					formControlName="customer_name"
					[ngClass]="{
						'is-invalid': submitted && form['customer_name'].errors
					}"
				/>
				<div
					*ngIf="submitted && form['customer_name'].errors"
					class="invalid-feedback"
					align="left"
				>
					<div *ngIf="form['customer_name'].errors['required']">
						Customer Name is required
					</div>
				</div>
			</div>

			<div class="mb-3">
				<label for="email-field" class="form-label">Email</label>
				<input
					type="email"
					id="email-field"
					class="form-control"
					placeholder="Enter Email"
					required
					formControlName="email"
					[ngClass]="{
						'is-invalid': submitted && form['email'].errors
					}"
				/>
				<div
					*ngIf="submitted && form['email'].errors"
					class="invalid-feedback"
					align="left"
				>
					<div *ngIf="form['email'].errors['required']">
						Email is required
					</div>
				</div>
			</div>

			<div class="mb-3">
				<label for="phone-field" class="form-label">Phone</label>
				<input
					type="text"
					id="phone-field"
					class="form-control"
					placeholder="Enter Phone no."
					required
					formControlName="phone"
					[ngClass]="{
						'is-invalid': submitted && form['phone'].errors
					}"
				/>
				<div
					*ngIf="submitted && form['phone'].errors"
					class="invalid-feedback"
					align="left"
				>
					<div *ngIf="form['phone'].errors['required']">
						Phone is required
					</div>
				</div>
			</div>

			<div class="mb-3">
				<label for="date-field" class="form-label">Joining Date</label>
				<input
					class="form-control flatpickr-input"
					type="text"
					mwlFlatpickr
					[altInput]="true"
					[convertModelValue]="true"
				/>
			</div>

			<div>
				<label for="status-field" class="form-label">Status</label>
				<select
					class="form-control"
					data-trigger
					name="status-field"
					id="status-field"
					formControlName="status"
					[ngClass]="{
						'is-invalid': submitted && form['status'].errors
					}"
				>
					<option value="">Status</option>
					<option value="Active">Active</option>
					<option value="Block">Block</option>
				</select>
				<div
					*ngIf="submitted && form['status'].errors"
					class="invalid-feedback"
					align="left"
				>
					<div *ngIf="form['status'].errors['required']">
						status is required
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<div class="hstack gap-2 justify-content-end">
				<button
					type="button"
					class="btn btn-light"
					data-bs-dismiss="modal"
					(click)="modal.close('Close click')"
				>
					Close
				</button>
				<button type="submit" class="btn btn-success" id="add-btn">
					Add Customer
				</button>
			</div>
		</div>
	</form>
</ng-template>
